<template>
  <!--
          作者：luoyiming
          时间：2019-10-25
          描述：会员-用户列表
      -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="用户信息">
          <el-input v-model="formInline.user_id" placeholder="请输入用户ID"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
          <el-button type="primary" icon="el-icon" @click="add">添加用户</el-button>
        </el-form-item>

      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="lottery_user_id" label="ID" width="80"></el-table-column>
          <el-table-column prop="user_id" label="用户ID" width="80"></el-table-column>
          <el-table-column prop="user.nickName" label="昵称"></el-table-column>
          <el-table-column prop="nickName" label="微信头像">
            <template slot-scope="scope" v-if="scope.row.user.avatarUrl">
              <img :src="scope.row.user.avatarUrl" width="30px" height="30px" />
            </template>
          </el-table-column>
          <el-table-column prop="user.mobile" label="手机号"></el-table-column>
          <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>


              </template>
            </el-table-column>  
        </el-table>
      </div>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
          :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"></el-pagination>
      </div>

      <GetUser :is_open="open_add" @close="closeDialogFunc"></GetUser>

    </div>
  </div>
</template>

<script>
 import GetUser from '@/components/user/GetUser.vue';
  import LotteryApi from '@/api/lottery.js';
  import qs from 'qs';
  export default {
    components: {
      GetUser,
    },
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        formInline: {
          user_id:""
        },
        open_add:false,

      };
    },
    created() {
      /*获取列表*/
      this.getTableList();
    },
    methods: {
      add(){
this.open_add = true;
      },
           /*关闭获取用户弹窗*/
           closeDialogFunc(e) {
            var self = this;
        if (e.type != 'error') {
          this.user = e.params[0];
          var user_id =  e.params[0].user_id;
          console.log("user_info",  e.params);
          var user_ids = "";
          for(var i=0;i<e.params.length;i++){
            user_ids+= e.params[i].user_id+",";
          }
          LotteryApi.addUser({
            user_ids:user_ids
          }, true)
          .then(res => {
            self.loading = false;
            self.$message({
                    type: 'success',
                    message: '添加成功'
                });
                self.getTableList();
          })
          .catch(error => {
            self.loading = false;
          });
        }
        self.open_add = false;
      },
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },
      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        LotteryApi.getUser(Params, true)
          .then(res => {
            self.loading = false;
            self.tableData = res.data.list.data;
            self.totalDataNumber = res.data.list.total;
          })
          .catch(error => {
            self.loading = false;
          });
      },
      /*搜索查询*/
      onSubmit() {
        let self = this;
        self.loading = true;
        self.curPage = 1;
        self.getTableList();
      },
      onExport: function() {
        let baseUrl = window.location.protocol + '//' + window.location.host;
        window.location.href = baseUrl + '/index.php/shop/plus.lottery/export?' + qs.stringify(this.formInline);
      },
       deleteClick(e) {
        let self = this;
        self.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          self.loading = true;
          LotteryApi.delUser({
            lottery_user_id: e.lottery_user_id
            }, true).then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.getTableList();

            })
            .catch(error => {
              self.loading = false;
            });

        }).catch(() => {
          self.loading = false;
        });
      }
    }
  };
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/plus/lottery/user.vue